import script from "./TreeView.vue?vue&type=script&lang=ts&setup=true"
export * from "./TreeView.vue?vue&type=script&lang=ts&setup=true"

import "./TreeView.vue?vue&type=style&index=0&id=ed6d0bae&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed6d0bae"]])

export default __exports__